import { createContext, Dispatch, SetStateAction } from "react";

import {
  Costing,
  OccupationPeriod,
} from "@/modules/dwelling/containers/DwellingEstimateContainer/types.ts";

export type TTotalRow = {
  quantity: number;
  preTaxPrice: number;
  taxPercentage: number;
  taxAmount: number;
  dilapidationPercentage: number;
  taxIncludedPrice: number;
};
export type TTotalCosting = {
  preTaxPrice: number;
  dilapidationDeducted: number;
  taxAmount: number;
  total: number;
};

export type TElement = {
  rows: Costing[];
  total: TTotalCosting;
  selected: boolean[];
};

export type TTotalCostingCleaning = {
  cleaning: {
    preTaxPrice: number;
    taxAmount: number;
    total: number;
  };
};

export type TElements = {
  [key: string]: TElement;
};

export type TCostingCalculate = {
  elements: TElements;
  total: TTotalCosting & TTotalCostingCleaning;
  occupationPeriod: OccupationPeriod;
};

interface ICalculateProvider {
  costingCalculate: TCostingCalculate;
  setCostingCalculate: Dispatch<SetStateAction<TCostingCalculate>>;
}

export const CalculateContext = createContext<ICalculateProvider>({
  costingCalculate: {
    occupationPeriod: {
      years: 0,
      months: 0,
      days: 0,
    },
    elements: {},
    total: {
      preTaxPrice: 0,
      taxAmount: 0,
      total: 0,
      dilapidationDeducted: 0,
      cleaning: {
        preTaxPrice: 0,
        taxAmount: 0,
        total: 0,
      },
    },
  },
  setCostingCalculate: () => {},
});
